<ion-content class="container">
  <div class="tabs-container">
    <div class="card">

      <div class="cardBoxallaccordian mb-20">
        <form [formGroup]="employeeForm">
          <ion-row class="pl-5 logos">
            <!-- First Logo -->
            <ion-col class="p-0 d-flex" size="6" size-sm="6" size-md="6" size-lg="6">
              <img src="././assets/icon/phiedgeSidebarpoweredbyIcon.jpg" class="logoHeight cp responsive-logo"
                style="margin-left: 20px;">
            </ion-col>

            <!-- Second Logo -->
            <ion-col class="p-0 d-flex justify-content-flex-end" size="6" size-sm="6" size-md="6" size-lg="6">
              <img src="././assets/icon/phiedgeSidebarpoweredbyIcon.jpg" class="logoHeight cp responsive-logo"
                style="margin-right: 30px;">
            </ion-col>

            <!-- Text/Label -->
            <ion-col size="12">
              <div class="font_bold fs-14 m-10">Application From</div>
            </ion-col>
          </ion-row>


          <div class="cardBox mb-20">
            <!--         
        <div class="cardBoxHeading font_medium fs-14">
            <ion-row class="pl-5">
                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <div class="font_bold fs-14">Employee Code Creation Logic Setup</div>
                </ion-col>
            </ion-row>
        </div> -->

            <mat-accordion>
              <!-- Salutation -->
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title>Genaral Information </mat-panel-title>
                </mat-expansion-panel-header>
                <ion-row class="responsive-form m-10" style="padding: 10px 20px 20px 20px;">
                  <!-- Salutation -->
                  <ion-col size="12" size-md="3">
                    <label>Salutation <span class="red-cl">&nbsp;*</span></label>
                    <!-- <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">

                      <mat-select placeholder="Select Salutation" formControlName="salutation" readonly>
                        <mat-option value="Mr.">Mr.</mat-option>
                        <mat-option value="Ms.">Ms.</mat-option>
                        <mat-option value="Mrs.">Mrs.</mat-option>
                        <mat-option value="Dr.">Dr.</mat-option>
                      </mat-select> -->
                      <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                        <input matInput placeholder="Enter First Name" formControlName="salutation" readonly/>
                      </mat-form-field>
                    
                    <mat-error *ngIf="hasError('salutation', 'required')">salutation is required</mat-error>
                  </ion-col>

                  <!-- First Name -->
                  <ion-col size="12" size-md="3">
                    <label>First Name <span class="red-cl">&nbsp;*</span></label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter First Name" formControlName="firstName" readonly />
                    </mat-form-field>
                    <mat-error *ngIf="hasError('firstName', 'required')">first name name is required</mat-error>
                  </ion-col>

                  <!-- Last Name -->
                  <ion-col size="12" size-md="3">
                    <label>Last Name <span class="red-cl">&nbsp;*</span></label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter Last Name" formControlName="lastName" readonly/>
                    </mat-form-field>
                    <mat-error *ngIf="hasError('lastName', 'required')">last name name is required</mat-error>
                  </ion-col>

                  <!-- Gender -->
                  <ion-col size="12" size-md="3">
                    <label>Gender <span class="red-cl">&nbsp;*</span></label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">

                      <mat-select placeholder="Select Gender" formControlName="gender">
                        <mat-option value="Male">Male</mat-option>
                        <mat-option value="Female">Female</mat-option>
                        <mat-option value="Other">Other</mat-option>

                      </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="hasError('gender', 'required')">gender name is required</mat-error>
                  </ion-col>


                  <ion-col size="12" size-md="3">
                    <label>Country <span class="red-cl">&nbsp;*</span></label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <mat-select placeholder="Select Country" formControlName="country">
                        <mat-option *ngFor="let item of getCountryList" [value]="item.id">{{item.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="hasError('country', 'required')" class="mb-10">country is required</mat-error>

                  </ion-col>
                  <!-- Present Address -->
                  <ion-col size="12" size-md="3">
                    <label>Present Address<span class="red-cl">&nbsp;*</span></label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter Present Address" formControlName="presentAddress" />
                    </mat-form-field>
                    <mat-error *ngIf="hasError('presentAddress', 'required')" class="mb-10">present address is required</mat-error>
                  </ion-col>


                  <!-- Permanent Address -->
                  <ion-col size="12" size-md="3">
                    <label>Permanent Address</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter Permanent Address" formControlName="permanentAddress" />
                    </mat-form-field>
                  </ion-col>
                  <ion-col size="12" size-md="3">
                    <label>Marital Satus<span class="red-cl">&nbsp;*</span></label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <mat-select placeholder="Select Marital Status" formControlName="maritalStatus">
                        <mat-option value="Single">Single</mat-option>
                        <mat-option value="Married">Married</mat-option>
                       <mat-option value="Divorced">Divorced</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="hasError('maritalStatus', 'required')" class="mb-10">marital status is required</mat-error>

                  </ion-col>
                  <!-- Date of Birth -->
                  <ion-col size="12" size-md="3">
                    <label>Date of Birth <span class="red-cl">&nbsp;*</span></label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput [matDatepicker]="picker" placeholder="Select Date of Birth"
                        formControlName="dateOfBirth"  (dateChange)="calculateAgeFromDOB()" [max]="currentDate"/>
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <mat-error *ngIf="hasError('dateOfBirth', 'required')">date of birth is required</mat-error>
                  </ion-col>

                  <!-- Age -->
                  <ion-col size="12" size-md="3">
                    <label>Age</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput type="number" placeholder="Enter Age" formControlName="age" readonly />
                    </mat-form-field>
                  </ion-col>

                  <ion-col size="12" size-md="3">
                    <label>Personal Email <span class="red-cl">&nbsp;*</span></label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput type="email" placeholder="Enter email" formControlName="personalEmail" readonly/>
                    </mat-form-field>
                    <!-- <mat-error *ngIf="hasError('personalEmail', 'required')">personal email is required</mat-error> -->
                    <mat-error *ngIf="hasError('personalEmail', 'required')">Mail is required</mat-error>
                    <mat-error *ngIf="hasError('personalEmail', 'email')">Enter a valid email address</mat-error>
                  </ion-col>
                  <ion-col size="12" size-md="3">
                    <label>Aadhaar Card No<span class="red-cl">&nbsp;*</span></label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput type="number" formControlName="aadhaarCardNo" placeholder="Enter Aadhaar No" (keypress)="handleInput($event, 'aadhaar')" />
                    </mat-form-field>
                    <mat-error *ngIf="hasError('aadhaarCardNo', 'required')">
                      aadhaar card number is required
                    </mat-error>
                  
                    <mat-error *ngIf="hasError('aadhaarCardNo', 'pattern')">
                      aadhaar card number must be exactly 12 digits
                    </mat-error>
                  </ion-col>

                  <ion-col size="12" size-md="3">
                    <label>PAN No. <span class="red-cl">*</span></label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput formControlName="panNo" placeholder="Enter PAN Number" (input)="handleInput($event, 'pan')"  />
                    </mat-form-field>
                    <mat-error *ngIf="hasError('panNo', 'required')">
                      pan number is required.
                    </mat-error>
                    <mat-error *ngIf="hasError('panNo', 'pattern')">
                      Enter a valid PAN number (e.g., ABCDE1234F).
                    </mat-error>
                  </ion-col>

                  <ion-col size="12" size-md="3">
                    <label>UAN No.</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput formControlName="unaNo" placeholder="Enter UAN Number" />
                    </mat-form-field>
                  </ion-col>

                  <ion-col size="12" size-md="3">
                    <label>Mobile No. (WhatsApp No) <span class="red-cl">*</span></label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input type="number" matInput formControlName="mobileNo" placeholder="Enter Mobile Number" (keypress)="handleInput($event, 'mobile')" />
                    </mat-form-field>
                    <mat-error *ngIf="hasError('mobileNo', 'required')">
                      mobile number is required.
                    </mat-error>
                    <mat-error *ngIf="hasError('mobileNo', 'pattern')">
                      enter a valid mobile number (starting with 7, 8, or 9 and followed by 9 digits).
                    </mat-error>
                  </ion-col>
                  <ion-col size="12" size-md="3">
                    <label>Total Previous Experience Before Joining</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input type="text" matInput formControlName="previousExperience"
                        placeholder="Enter Total Experience" />
                    </mat-form-field>
                  </ion-col>

                  <ion-col size="12" size-md="3">
                    <label>Emergency Contact Number</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input type="number" matInput formControlName="emergencyContact"
                        placeholder="Enter Emergency Contact"(keypress)="handleInput($event, 'emergencyContact')" />
                    </mat-form-field>
                  </ion-col>

                  <ion-col size="12" size-md="3">
                    <label>Blood Group</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <mat-select formControlName="bloodGroup" placeholder="Select Blood Group">
                        <mat-option *ngFor="let bloodGroup of bloodGroups" [value]="bloodGroup">
                          {{ bloodGroup }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>

                  <ion-col size="12" size-md="3">
                    <label>Father's Name</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input type="text" matInput formControlName="fathersName" placeholder="Enter Father's Name" />
                    </mat-form-field>
                  </ion-col>

                  <ion-col size="12" size-md="3">
                    <label>Mother's Name</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input type="text" matInput formControlName="mothersName" placeholder="Enter Mother's Name" />
                    </mat-form-field>
                  </ion-col>

                  <ion-col size="12" size-md="3">
                    <label>Spouse's Name</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input type="text" matInput formControlName="spouseName" placeholder="Enter Spouse's Name" />
                    </mat-form-field>
                  </ion-col>

                  <ion-col size="12" size-md="3">
                    <label>No Of Children</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input type="number" matInput formControlName="noOfChildren" placeholder="No Of Children" />
                    </mat-form-field>
                  </ion-col>

                  <ion-col size="12" size-md="3">
                    <label>Is Relative Working?</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input type="text" matInput formControlName="relativeWorking" placeholder="Enter Details" />
                    </mat-form-field>
                  </ion-col>
                  <!-- Additional Fields Here -->
                </ion-row>
              </mat-expansion-panel>
            </mat-accordion>

          </div>

          <div class="cardBox mb-20">

            <mat-accordion>


              <!-- Education Related Information -->
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>Education Related Information</mat-panel-title>
                </mat-expansion-panel-header>
                <ion-row class="responsive-form m-10" style="padding: 10px 20px 20px 20px;">
                  <!-- Highest Education Qualification -->
                  <ion-col size="12" size-md="3">
                    <label>Highest Education Qualification</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter Highest Education Qualification"
                        formControlName="highestEducation" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Highest Education Institute -->
                  <ion-col size="12" size-md="3">
                    <label>Highest Education Institute</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter Highest Education Institute"
                        formControlName="highestEducationInstitute" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Highest Education Year of Passing -->
                  <ion-col size="12" size-md="3">
                    <label>Highest Education Year of Passing</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput type="number" placeholder="Enter Year of Passing"
                        formControlName="highestEducationYear" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Highest Education Marks/% -->
                  <ion-col size="12" size-md="3">
                    <label>Highest Education Marks/%</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput type="text" placeholder="Enter Marks/%" formControlName="highestEducationMarks" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Second Highest Education Qualification -->
                  <ion-col size="12" size-md="3">
                    <label>2nd Highest Education Qualification</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter 2nd Highest Education Qualification"
                        formControlName="secondEducation" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Second Highest Education Institute -->
                  <ion-col size="12" size-md="3">
                    <label>2nd Highest Education Institute</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter 2nd Highest Education Institute"
                        formControlName="secondEducationInstitute" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Second Highest Education Year of Passing -->
                  <ion-col size="12" size-md="3">
                    <label>2nd Highest Education Year of Passing</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput type="number" placeholder="Enter Year of Passing"
                        formControlName="secondEducationYear" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Second Highest Education Marks/% -->
                  <ion-col size="12" size-md="3">
                    <label>2nd Highest Education Marks/%</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput type="text" placeholder="Enter Marks/%" formControlName="secondEducationMarks" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Third Highest Education Qualification -->
                  <ion-col size="12" size-md="3">
                    <label>3rd Highest Education Qualification</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter 3rd Highest Education Qualification"
                        formControlName="thirdEducation" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Third Highest Education Institute -->
                  <ion-col size="12" size-md="3">
                    <label>3rd Highest Education Institute</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter 3rd Highest Education Institute"
                        formControlName="thirdEducationInstitute" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Third Highest Education Year of Passing -->
                  <ion-col size="12" size-md="3">
                    <label>3rd Highest Education Year of Passing</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput type="number" placeholder="Enter Year of Passing"
                        formControlName="thirdEducationYear" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Third Highest Education Marks/% -->
                  <ion-col size="12" size-md="3">
                    <label>3rd Highest Education Marks/%</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput type="text" placeholder="Enter Marks/%" formControlName="thirdEducationMarks" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Highest Professional Qualification -->
                  <ion-col size="12" size-md="3">
                    <label>Highest Professional Qualification</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter Highest Professional Qualification"
                        formControlName="highestProfessional" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Highest Professional Institute -->
                  <ion-col size="12" size-md="3">
                    <label>Highest Professional Institute</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter Highest Professional Institute"
                        formControlName="highestProfessionalInstitute" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Highest Professional Year of Passing -->
                  <ion-col size="12" size-md="3">
                    <label>Highest Professional Year of Passing</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput type="number" placeholder="Enter Year of Passing"
                        formControlName="highestProfessionalYear" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Highest Professional Marks/% -->
                  <ion-col size="12" size-md="3">
                    <label>Highest Professional Marks/%</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput type="text" placeholder="Enter Marks/%"
                        formControlName="highestProfessionalMarks" />
                    </mat-form-field>
                  </ion-col>
                </ion-row>

              </mat-expansion-panel>
            </mat-accordion>

          </div>
          <div class="cardBox mb-20">
            <mat-accordion>


              <!-- Prior Employment Related Information -->
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>Prior Employment Related Information</mat-panel-title>
                </mat-expansion-panel-header>
                <ion-row class="responsive-form m-10" style="padding: 10px 20px 20px 20px;">
                  <!-- Last Organisation Before Joining -->
                  <ion-col size="12" size-md="3">
                    <label>Last Organisation Before Joining</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter Last Organisation" [formControlName]="'lastOrganisation'" />
                    </mat-form-field>
                  </ion-col>

                  <ion-col size="12" size-md="3">
                    <label>Last Organisation Date Of Joining</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10" >
                      <input matInput [matDatepicker]="joiningPicker" placeholder="Select Date Of Joining"
                        formControlName="lastOrganisationJoiningDate">
                      <mat-datepicker-toggle matSuffix [for]="joiningPicker"></mat-datepicker-toggle>
                      <mat-datepicker #joiningPicker></mat-datepicker>
                    </mat-form-field>

                    
                  </ion-col>

                  <!-- Last Organisation Last Working Date -->
                  <ion-col size="12" size-md="3">
                    <label>Last Organisation Last Working Date</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10"  >
                      <input matInput [matDatepicker]="lastWorkingPicker" placeholder="Select Last Working Date"
                        formControlName="lastOrganisationLastWorkingDate">
                      <mat-datepicker-toggle matSuffix [for]="lastWorkingPicker"></mat-datepicker-toggle>
                      <mat-datepicker #lastWorkingPicker></mat-datepicker>
                    </mat-form-field>
                  </ion-col>

                  <!-- Last Organisation Department -->
                  <ion-col size="12" size-md="3">
                    <label>Last Organisation Department</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter Department" [formControlName]="'lastOrganisationDepartment'" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Last Organisation Designation -->
                  <ion-col size="12" size-md="3">
                    <label>Last Organisation Designation</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter Designation"
                        [formControlName]="'lastOrganisationDesignation'" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Last to Last Organisation -->
                  <ion-col size="12" size-md="3">
                    <label>Last to Last Organisation Before Joining</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter Organisation" [formControlName]="'lastToLastOrganisation'" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Last to Last Organisation Date Of Joining -->
                  <!-- Last to Last Organisation Date Of Joining -->
                  <ion-col size="12" size-md="3">
                    <label>Last to Last Organisation Date Of Joining</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10"  >
                      <input matInput [matDatepicker]="lastToLastJoiningPicker" placeholder="Select Date Of Joining"
                        formControlName="lastToLastOrganisationJoiningDate">
                      <mat-datepicker-toggle matSuffix [for]="lastToLastJoiningPicker"></mat-datepicker-toggle>
                      <mat-datepicker #lastToLastJoiningPicker></mat-datepicker>
                    </mat-form-field>
                  </ion-col>

                  <!-- Last to Last Organisation Last Working Date -->
                  <ion-col size="12" size-md="3">
                    <label>Last to Last Organisation Last Working Date</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10"  >
                      <input matInput [matDatepicker]="lastToLastWorkingPicker" placeholder="Select Last Working Date"
                        formControlName="lastToLastOrganisationLastWorkingDate">
                      <mat-datepicker-toggle matSuffix [for]="lastToLastWorkingPicker"></mat-datepicker-toggle>
                      <mat-datepicker #lastToLastWorkingPicker></mat-datepicker>
                    </mat-form-field>
                  </ion-col>


                  <!-- Last to Last Organisation Department -->
                  <ion-col size="12" size-md="3">
                    <label>Last to Last Organisation Department</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter Department"
                        [formControlName]="'lastToLastOrganisationDepartment'" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Last to Last Organisation Designation -->
                  <ion-col size="12" size-md="3">
                    <label>Last to Last Organisation Designation</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter Designation"
                        [formControlName]="'lastToLastOrganisationDesignation'" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Any Other Organisation Joined Before -->
                  <ion-col size="12" size-md="3">
                    <label>Any Other Organisation Joined Before</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter Organisation" [formControlName]="'anyOtherOrganisation'" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Any Other Organisation Date Of Joining -->
                  <!-- Any Other Organisation Date Of Joining -->
                  <ion-col size="12" size-md="3">
                    <label>Any Other Organisation Date Of Joining</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10"  >
                      <input matInput [matDatepicker]="anyOtherJoiningPicker" placeholder="Select Date Of Joining"
                        formControlName="anyOtherOrganisationJoiningDate">
                      <mat-datepicker-toggle matSuffix [for]="anyOtherJoiningPicker"></mat-datepicker-toggle>
                      <mat-datepicker #anyOtherJoiningPicker></mat-datepicker>
                    </mat-form-field>
                  </ion-col>

                  <!-- Any Other Organisation Last Working Date -->
                  <ion-col size="12" size-md="3">
                    <label>Any Other Organisation Last Working Date</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10"  >
                      <input matInput [matDatepicker]="anyOtherLastWorkingPicker" placeholder="Select Last Working Date"
                        formControlName="anyOtherOrganisationLastWorkingDate">
                      <mat-datepicker-toggle matSuffix [for]="anyOtherLastWorkingPicker"></mat-datepicker-toggle>
                      <mat-datepicker #anyOtherLastWorkingPicker></mat-datepicker>
                    </mat-form-field>
                  </ion-col>


                  <!-- Any Other Organisation Department -->
                  <ion-col size="12" size-md="3">
                    <label>Any Other Organisation Department</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter Department"
                        [formControlName]="'anyOtherOrganisationDepartment'" />
                    </mat-form-field>
                  </ion-col>

                  <!-- Any Other Organisation Designation -->
                  <ion-col size="12" size-md="3">
                    <label>Any Other Organisation Designation</label>
                    <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                      <input matInput placeholder="Enter Designation"
                        [formControlName]="'anyOtherOrganisationDesignation'" />
                    </mat-form-field>
                  </ion-col>
                </ion-row>

              </mat-expansion-panel>
            </mat-accordion>

          </div>
          <ion-row>
            <ion-col size="12" class="text-right mt-10">
              <!-- <button (click)="closeDialog()" class="back_btn fs-14">Cancel</button> -->
              <button type="button" class="add_btn fs-14 ml-10" [style.background-color]="buttonColorName"
                (click)="saveEmployeeeData()">
                Save
              </button>
            </ion-col>
          </ion-row>
        </form>
      </div>
    </div>


  </div>
</ion-content>